import React from "react"
import {
	Zoom,
	Grid,
	Typography
} from "@material-ui/core"

import useStyles from "@/pages/Attendance/Chat/ConversationPanel/Input/InputBlockMessage/styles"

type InputBlockMessageProps = {
	blocked: boolean
}

const InputBlockMessage: React.FC<InputBlockMessageProps> = (props) => {
	const { blocked, children } = props

	const classes = useStyles()

	return (
		<Zoom in={blocked}>
			<Grid
				container
				alignItems="center"
				className={classes.blockedChatContainer}
			>
				<Typography
					variant="body1"
					color="textPrimary"
					align="left"
				>
					{children}
				</Typography>
			</Grid>
		</Zoom>
	)
}

export default InputBlockMessage
